import shared from 'emun.activity/activity.config.es6'

const activityConfig = Object.assign({}, shared, {
  googleApi: false,
  outlookApi: false,
	hideTimeZoneOptions: true,
  hideAddActivity: false,
  timeZoneMessage: "Please enter the time as it would be in"
});

export default activityConfig;